import { createContext, useContext } from "react"

export interface ISettingsContext {
    displayApplySuggestionsButton: boolean
    useSessionStorage: boolean
    isWebApp: boolean
}

export const SettingsContext = createContext({} as ISettingsContext);

export function useSettings() {
    return useContext(SettingsContext);
}